export default __webpack_public_path__ + "static/media/Lotus.d01c8d48.png";